import { M7_UNIT_1 } from './Unit1';
import { M7_UNIT_2 } from './Unit2';
import { M7_UNIT_3 } from './Unit3';
import { M7_UNIT_4 } from './Unit4';
import { M7_UNIT_5 } from './Unit5';
import { M7_UNIT_6 } from './Unit6';
import { M7_UNIT_7 } from './Unit7';
import { M7_UNIT_8 } from './Unit8';
import { M7_UNIT_9 } from './Unit9';
import { M7_UNIT_10 } from './Unit10';
import { M7_UNIT_11 } from './Unit11';
import { M7_UNIT_12 } from './Unit12';
import { M7_READING_PRACTICE } from './ReadingPractice';
import { M7_MODULE_REVIEW } from './UnitReview';


export const MODULE_7_UNITS = [
  M7_UNIT_1,
  M7_UNIT_2,
  M7_UNIT_3,
  M7_UNIT_4,
  M7_UNIT_5,
  M7_UNIT_6,
  M7_UNIT_7,
  M7_UNIT_8,
  M7_UNIT_9,
  M7_UNIT_10,
  M7_UNIT_11,
  M7_UNIT_12,
  M7_READING_PRACTICE,
  M7_MODULE_REVIEW,
];
